export const RBAC_URL = 'rbac'
export const RBAC_SCOPES_URL = 'scopes'
export const RBAC_ASSIGNMENTS_URL = 'role-assignments'
